import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const SITE_ACCESS_STORAGE_KEY = 'siteAccessVerified';

const isAuthenticated = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('authData') || '{}');
    return !!authData?.token || !!authData?.accessToken;
  } catch (error) {
    console.error('Auth check error:', error);
    return false;
  }
};

export const PublicRoute = ({ children }) => {
  const auth = isAuthenticated();
  
  if (auth) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();

  if (!auth) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const isSiteAccessVerified = () => {
  return localStorage.getItem(SITE_ACCESS_STORAGE_KEY) === 'true';
};

export const setSiteAccessVerified = () => {
  localStorage.setItem(SITE_ACCESS_STORAGE_KEY, 'true');
};

export const SiteAccessRoute = () => {
  const location = useLocation();

  if (isSiteAccessVerified()) {
    return <Outlet />;
  }

  const nextPath = `${location.pathname}${location.search}`;
  return (
    <Navigate
      to={`/site-access?next=${encodeURIComponent(nextPath)}`}
      replace
    />
  );
};